






























import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {NotasInseridasFilterCollection} from '@/model/filter/NotasInseridasFilterCollection'
import {NotasInseridasFilterSchema} from '@/schema/filter/NotasInseridasFilterSchema'

@Component
export default class NotasInseridasFilter extends Vue {
  @Prop({type: Object, required: true}) filter!: NotasInseridasFilterCollection
  @Prop({type: Boolean}) isWeekly?: boolean

  schema = new NotasInseridasFilterSchema()

  created() {
    this.applyFilter()
  }

  async applyFilter() {
    this.filter.resource = this.schema

    const promises: Array<Promise<any>> = [this.filter.yearOptions()]
    await this.$await.run('adapQuery', () => Promise.all(promises))
  }

  async submitEvent() {
    this.$emit('submit')
    this.filter.setCurrentPage(0)
    await this.$await.run('adapQuery', () => this.filter.queryAsPage())
  }
}
